module.exports = __webpack_public_path__ + "img/DE04582.088d8cbe.svg";